import { useLocation } from "@reach/router"
import { Link } from "gatsby"
import React, { useEffect, useRef, useState } from "react"
// import slugify from "@sindresorhus/slugify"
import {
  activeLink,
  desktop,
  hamburgerButton,
  mobileLinks,
  mobileMenu,
  navLink,
  navStyle,
} from "./navigation.module.css"
// import { useSlideAnimation } from '../../utils/gsapUtils';
import { CartButton } from "../../components/cart-button"
import { StoreContext } from "../../context/store-context"

export function Navigation({ className, version, hiddenLinks = [] }) {
  /*const {
    allShopifyProduct: { productTypes },
  } = useStaticQuery(graphql`
    {
      allShopifyProduct {
        productTypes: distinct(field: { productType: SELECT })
      }
    }
  `)*/

  //hook for page transition
  // useSlideAnimation(navLink);

  const { cart, loading, didJustAddToCart } = React.useContext(StoreContext)

  const items = cart ? cart.lines : []

  const quantity = items.reduce((total, item) => {
    return total + item.quantity
  }, 0)

  const location = useLocation()
  const isAdvisoryPage = location.pathname.includes("/advisory")

  const [mobileMenuVisible, setMobileMenuVisible] = useState(false)
  const mobileMenuRef = useRef(null)

  const toggleMobileMenu = () => {
    setMobileMenuVisible(!mobileMenuVisible)
  }

  const isLinkHidden = (linkKey) =>
    hiddenLinks.includes(linkKey) && (linkKey !== "home" || !mobileMenuVisible)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        mobileMenuVisible &&
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setMobileMenuVisible(false)
      }
    }

    document.addEventListener("click", handleClickOutside)

    return () => {
      document.removeEventListener("click", handleClickOutside)
    }
  }, [mobileMenuVisible])

  return (
    <>
      <nav className={[navStyle, className, version].join(" ")}>
        <div className={desktop}>
          <Link
            key="home"
            className={`${navLink} ${isLinkHidden("home") ? "hidden" : ""}`}
            to="/"
            activeClassName={activeLink}
          >
            HOME
          </Link>
          <Link
            key="about-us"
            className={`${navLink} ${isLinkHidden("about") ? "hidden" : ""}`}
            to="/about/"
            activeClassName={activeLink}
          >
            About
          </Link>
          <Link
            key="artists"
            className={`${navLink} ${isLinkHidden("artists") ? "hidden" : ""}`}
            to="/artists/"
            activeClassName={activeLink}
          >
            Artists
          </Link>
          <Link
            key="advisory"
            className={`${navLink} ${isLinkHidden("advisory") ? "hidden" : ""}`}
            to="/advisory/"
            activeClassName={activeLink}
          >
            Advisory
          </Link>

          <Link
            key="news"
            className={navLink}
            to="/news/"
            activeClassName={activeLink}
          >
            News
          </Link>

          <Link
            key="visit"
            className={`${navLink} ${isLinkHidden("visit") ? "hidden" : ""
              } no-slide-animation`}
            to="/#visit"
            activeClassName={activeLink}
          >
            Visit
          </Link>

          <Link
            key="All"
            className={navLink}
            to="/products/"
            activeClassName={activeLink}
          >
            All Artworks
          </Link>

          {/* {productTypes.map((name) => (
        <Link
          key={name}
          className={navLink}
          to={`/products/${slugify(name)}`}
          activeClassName={activeLink}
        >
          {name}
        </Link>
      ))} */}
          {/* 
       {/* <Link
        key="guide"
        className={navLink}
        to="/guide/"
        */}

          {isAdvisoryPage && (
            <Link
              key="Book-Call"
              className={`${navLink} ${isLinkHidden("visit") ? "bookcall" : ""
                }`}
              to="/book-call/"
              activeClassName={activeLink}
            >
              BOOK A CALL
            </Link>
          )}

          {/* testing purpose only */}

          {/* <Toast show={loading || didJustAddToCart} 
         >
          {!didJustAddToCart ? (
            "Updating…"
          ) : (
            <>
              Added to cart{" "}
              <svg
                width="14"
                height="14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.019 10.492l-2.322-3.17A.796.796 0 013.91 6.304L6.628 9.14a1.056 1.056 0 11-1.61 1.351z"
                  fill="#fff"
                />
                <path
                  d="M5.209 10.693a1.11 1.11 0 01-.105-1.6l5.394-5.88a.757.757 0 011.159.973l-4.855 6.332a1.11 1.11 0 01-1.593.175z"
                  fill="#fff"
                />
                <path
                  d="M5.331 7.806c.272.326.471.543.815.163.345-.38-.108.96-.108.96l-1.123-.363.416-.76z"
                  fill="#fff"
                />
              </svg>
            </>
          )}
        </Toast> */}
        </div>

        {/* needs to be uncommented on stage 3 */}
        <CartButton quantity={quantity} />

        <div className={mobileMenu} ref={mobileMenuRef}>
          <button
            onClick={() => setMobileMenuVisible(!mobileMenuVisible)}
            className={`${hamburgerButton} ${mobileMenuVisible ? "open" : ""}`}
            title="Navigation Menu"
          >
            {mobileMenuVisible ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="42"
                height="30"
                viewBox="0 0 52 24"
              >
                <g
                  id="Group_9"
                  data-name="Group 9"
                  transform="translate(-294 -47)"
                >
                  <rect
                    id="Rectangle_3"
                    data-name="Rectangle 3"
                    width="42"
                    height="4"
                    rx="2"
                    transform="translate(304 47)"
                    fill="white"
                  />
                  <rect
                    id="Rectangle_5"
                    data-name="Rectangle 5"
                    width="42"
                    height="4"
                    rx="2"
                    transform="translate(304 67)"
                    fill="white"
                  />
                  <rect
                    id="Rectangle_4"
                    data-name="Rectangle 4"
                    width="52"
                    height="4"
                    rx="2"
                    transform="translate(294 57)"
                    fill="white"
                  />
                </g>
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="42"
                height="30"
                viewBox="0 0 52 24"
              >
                <g
                  id="Group_9"
                  data-name="Group 9"
                  transform="translate(-294 -47)"
                >
                  <rect
                    id="Rectangle_3"
                    data-name="Rectangle 3"
                    width="42"
                    height="4"
                    rx="2"
                    transform="translate(304 47)"
                    fill="white"
                  />
                  <rect
                    id="Rectangle_5"
                    data-name="Rectangle 5"
                    width="42"
                    height="4"
                    rx="2"
                    transform="translate(304 67)"
                    fill="white"
                  />
                  <rect
                    id="Rectangle_4"
                    data-name="Rectangle 4"
                    width="52"
                    height="4"
                    rx="2"
                    transform="translate(294 57)"
                    fill="white"
                  />
                </g>
              </svg>
            )}
          </button>
          {mobileMenuVisible && (
            <div className={mobileLinks}>
              <Link
                key="home"
                className={`${navLink} ${isLinkHidden("home") ? "hidden" : ""}`}
                to="/"
                activeClassName={activeLink}
              >
                Home
              </Link>
              <Link
                key="about-us"
                className={`${navLink} ${isLinkHidden("about") ? "hidden" : ""
                  }`}
                to="/about/"
                activeClassName={activeLink}
              >
                About
              </Link>
              <Link
                key="artists"
                className={`${navLink} ${isLinkHidden("artists") ? "hidden" : ""
                  }`}
                to="/artists/"
                activeClassName={activeLink}
              >
                Artists
              </Link>
              <Link
                key="advisory"
                className={`${navLink} ${isLinkHidden("advisory") ? "hidden" : ""
                  }`}
                to="/advisory/"
                activeClassName={activeLink}
              >
                Advisory
              </Link>
              <Link
                key="news"
                className={`${navLink} ${isLinkHidden("news") ? "hidden" : ""}`}
                to="/news/"
                activeClassName={activeLink}
              >
                News
              </Link>
              <Link
                key="All"
                className={`${navLink} ${isLinkHidden("All") ? "hidden" : ""}`}
                to="/products/"
                activeClassName={activeLink}
              >
                All Artworks
              </Link>
              <Link
                key="visit"
                className={`${navLink} ${isLinkHidden("visit") ? "hidden" : ""
                  }`}
                to="/#visit"
                activeClassName={activeLink}
              >
                Visit
              </Link>
              {isAdvisoryPage && (
                <Link
                  key="Book-Call"
                  className={`${navLink} ${isLinkHidden("visit") ? "bookcall" : ""
                    }`}
                  to="/book-call/"
                  activeClassName={activeLink}
                >
                  BOOK A CALL
                </Link>
              )}
            </div>
          )}
        </div>
      </nav>
    </>
  )
}
